module.exports = __webpack_public_path__ + "img/type10120.ec01827b.png";